import { styled } from 'styled-components';

export const ScSmallLockedGameCardInner = styled.div`
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 12px;
  position: relative;
  z-index: 1;
  overflow: hidden;

  & .content {
    position: absolute;
    inset: 0;
    z-index: 3;
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.8) 0%,
      rgba(0, 0, 0, 0.8) 100%
    );
    padding: 0px 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const ScSmallLockedGameCardIcon = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 360px;
  background: rgba(255, 255, 255, 0.2);
`;
